<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>面经管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateInterviewExpDialog()">
          新增面经
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="interviewExperiences"
      :items-per-page="itemsPerPage"
      :page.sync="page"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      :loading="loading"
      @update:page="handlePageChange"
      @update:items-per-page="handleItemsPerPageChange"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small class="mr-2" @click="showEditInterviewExpDialog(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn small @click="showDeleteInterviewExpDialog(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <create-interview-exp-popup
      ref="createInterviewExpPopup"
      @interview-exp-created="handleInterviewExpCreated"
    ></create-interview-exp-popup>

    <edit-interview-exp-popup
      ref="editInterviewExpPopup"
      :item="selectedInterviewExp"
      @interview-exp-updated="handleInterviewExpUpdated"
    ></edit-interview-exp-popup>

    <delete-interview-exp-popup
      ref="deleteInterviewExpPopup"
      :item="selectedInterviewExp"
      @interview-exp-deleted="handleInterviewExpDeleted"
    ></delete-interview-exp-popup>
  </v-container>
</template>

<script>
import { interviewApi } from '@/api/interview'
import CreateInterviewExpPopup from '@/components/CreateInterviewExpPopup.vue'
import EditInterviewExpPopup from '@/components/EditInterviewExpPopup.vue'
import DeleteInterviewExpPopup from '@/components/DeleteInterviewExpPopup.vue'

export default {
  components: {
    CreateInterviewExpPopup,
    EditInterviewExpPopup,
    DeleteInterviewExpPopup
  },
  
  data() {
    return {
      loading: false,
      headers: [
        { text: "公司名称", value: "companyName" },
        { text: "职位名称", value: "jobTitle" },
        { text: "浏览次数", value: "viewCount" },
        { text: "操作", value: "actions", sortable: false }
      ],
      interviewExperiences: [],
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
      selectedInterviewExp: {},
      itemsPerPageOptions: [10,30,50,100],
    };
  },

  async created() {
    await this.fetchInterviewExperiences();
  },

  methods: {
    async fetchInterviewExperiences() {
      this.loading = true;
      try {
        const response = await interviewApi.getInterviewExperiences(this.page, this.itemsPerPage);
        this.interviewExperiences = response.data.interviewExperienceList.map(exp => ({
          ...exp,
          experienceDetail: exp.detail
        }));
        this.totalItems = response.data.pageTotal * this.itemsPerPage;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取面经列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },

    handlePageChange() {
      this.fetchInterviewExperiences();
    },

    handleItemsPerPageChange(newSize) {
      this.itemsPerPage = newSize
      this.currentPage = 1
      this.fetchInterviewExperiences();
    },

    showCreateInterviewExpDialog() {
      this.$refs.createInterviewExpPopup.open();
    },

    showEditInterviewExpDialog(item) {
      this.selectedInterviewExp = item;
      this.$refs.editInterviewExpPopup.open();
    },

    showDeleteInterviewExpDialog(item) {
      this.selectedInterviewExp = item;
      this.$refs.deleteInterviewExpPopup.open();
    },

    handleInterviewExpCreated() {
      this.fetchInterviewExperiences();
    },

    handleInterviewExpUpdated() {
      this.fetchInterviewExperiences();
    },

    handleInterviewExpDeleted() {
      this.fetchInterviewExperiences();
    }
  }
};
</script>
